import {Card} from 'platform/components';
import {GridItem, Heading, Space, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {CarParkIdSelect} from '../../kit/components/CarParkIdSelect';
import {RentalAvailabilityFromDatePicker} from '../../kit/components/RentalAvailabilityFromDatePicker';
import {RentalAvailabilityMileageLimit} from '../../kit/components/RentalAvailabilityMileageLimit';
import {RentalAvailabilityToDatePicker} from '../../kit/components/RentalAvailabilityToDatePicker';
import {RentalEquipmentCheckboxes} from '../../kit/components/RentalEquipmentCheckboxes';
import {RentalNoteTextarea} from '../../kit/components/RentalNoteTextarea';
import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function RentalInformationSubSection() {
  return (
    <Card title={i18n.t('entity.vehicle.labels.rentalInformation')} variant="inlineGrey">
      <VFKit.Group columns={4} data-testid="rental-information-group">
        <CarParkIdSelect />
        <RentalAvailabilityMileageLimit />
        <RentalAvailabilityFromDatePicker />
        <RentalAvailabilityToDatePicker />

        <GridItem span={4}>
          <RentalNoteTextarea />
        </GridItem>
      </VFKit.Group>

      <Space vertical={4} />

      <VStack spacing={4}>
        <Heading size={4}>{i18n.t('entity.rental.labels.equipment')}</Heading>
        <RentalEquipmentCheckboxes />
      </VStack>
    </Card>
  );
}
